var _path, _path2, _circle, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicLinkLockSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 93,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 30.764V18.203a18.19 18.19 0 10-36.379 0v12.561A9.457 9.457 0 00.39 40.208v29.684h54.443V40.209a9.458 9.458 0 00-9.032-9.444zM27.61 6.418a11.798 11.798 0 0111.785 11.785v12.54H15.826v-12.54A11.798 11.798 0 0127.611 6.418z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.504 45.386a4.893 4.893 0 10-7.646 4.045v10.637h5.505V49.43a4.887 4.887 0 002.141-4.044z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.611,
    cy: 20,
    r: 16,
    fill: "#5ACD81"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 85.892,
    rx: 18,
    ry: 7,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.333 17L46 24.333 42.667 21",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/magic-link-lock-success.3c1a4735.svg";
export { SvgMagicLinkLockSuccess as ReactComponent };